module.exports = __webpack_public_path__ + "media/images/icons/icon-twitter-b676c67123e2309daa510c76b69fb085.svg";